import { Component, InjectionToken, Inject } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';

interface DialogData {
    title: string;
    errors: string[];
}

export const UPLOAD_ERROR_DIALOG_DATA_TOKEN = new InjectionToken<DialogData>('UploadErrorDialog');

@Component({
    selector: 'app-upload-error-dialog',
    template: require('./upload-error-dialog.component.html'),
    styles: [require('./upload-error-dialog.component.scss')]
})
export class UploadErrorDialogComponent {
    constructor(
        private readonly dialog: MdlDialogReference,
        @Inject(UPLOAD_ERROR_DIALOG_DATA_TOKEN) public data: DialogData
    ) { }

    public close() {
        this.dialog.hide();
    }
}